import { detectarDisplayMode } from '@shared/pwa/utils/displayMode';
import logger from '@/logger';

export const CHAVE_INSTALACAO_REGISTRADA = 'pwa-instalacao-registrada';

export function lerMarcaLocal(chave: string): boolean {
  try {
    return localStorage.getItem(chave) === 'true';
  } catch (error) {
    logger.error.andTrackError(error instanceof Error ? error : new Error(String(error)));
    return false;
  }
}

export function gravarMarcaLocal(chave: string) {
  try {
    localStorage.setItem(chave, 'true');
  } catch (error) {
    logger.error.andTrackError(error instanceof Error ? error : new Error(String(error)));
  }
}

/**
 * Fora do app, o navegador não diz se ele está instalado. A marca da instalação cobre esse caso no
 * Android/Desktop, onde o app divide o armazenamento com o navegador; no iOS ela fica só no
 * armazenamento do app, e o Safari continua sem saber.
 */
export function calcularJaInstalado(): boolean {
  return detectarDisplayMode() === 'standalone' || lerMarcaLocal(CHAVE_INSTALACAO_REGISTRADA);
}
